module.exports = __webpack_public_path__ + "static/img/5459_phase_function_Paper_PointsHejduk_Prediction.9a72d68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5459_phase_function_Paper_PointsHejduk_Prediction.png
// module id = iIO+
// module chunks = 0